import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { authCallbackUri, fetchToken, getAccessToken, storeTokenResponse } from "./app/auth";
interface AuthContextType
{
    isAuthenticated: boolean;
}
const AuthContext = createContext<AuthContextType | undefined>( undefined );

function buildLoginPath( domain: string, callbackUri: string )
{
    const searchParams = new URLSearchParams( {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        client_id: process.env.REACT_APP_COGNITO_CLIENT_ID!,
        response_type: "code",
        redirect_uri: callbackUri,
    } );
    return new URL(
        `${domain}/oauth2/authorize?${searchParams}&scope=email+openid`
    );
}
export const AuthProvider: React.FC<{ children: ReactNode }> = ( { children } ) =>
{

    const [ isAuthenticated, setIsAuthenticated ] = useState<boolean>( false );
    useEffect( () =>
    {
        if ( typeof window !== "undefined" )
        {
            const token = getAccessToken();

            if ( token === null )
            {
                const params = new URL( document.location.href ).searchParams;
                const code = params.get( "code" );

                if ( code === null )
                {
                    window.location.replace(
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        buildLoginPath( process.env.REACT_APP_OAUTH_DOMAIN!, authCallbackUri )
                    );
                }

                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const promise = fetchToken( code! );
                promise
                    .then( ( response ) =>
                    {
                        const isOk: boolean = response.ok;
                        if ( isOk )
                        {
                            setIsAuthenticated( true );
                            return response.json();
                        }

                        return Promise.reject( "Error fetching token for code" );
                    } )
                    .then( ( json ) =>
                    {
                        storeTokenResponse( json );
                        window.location.replace(
                            window.location.origin + window.location.pathname
                        );
                    } )
                    .catch( ( error ) =>
                    {
                        console.error( "Failed to get token:", error );
                    } );
            }
            else
            {
                setIsAuthenticated( true );
            }
        }
    }, [] );


    return (
        <AuthContext.Provider value = {{ isAuthenticated }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () =>
{
    const context = useContext( AuthContext );
    if ( context === undefined )
    {
        throw new Error( "useAuth must be used within an AuthProvider" );
    }
    return context;
};
